import { render, staticRenderFns } from "./spareGetAdd.vue?vue&type=template&id=1e765060&scoped=true"
import script from "./spareGetAdd.vue?vue&type=script&lang=js"
export * from "./spareGetAdd.vue?vue&type=script&lang=js"
import style0 from "./spareGetAdd.vue?vue&type=style&index=0&id=1e765060&prod&scoped=true&lang=scss"
import style1 from "./spareGetAdd.vue?vue&type=style&index=1&id=1e765060&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1e765060",
  null
  
)

export default component.exports